import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../../../../tools/forms/input/input.component';
import { FormsModule } from '@angular/forms';
import { ToastNotifService } from '../../../../core/services/toast-notif.service';
import { CityParkingDiscountDetailsResponse, CityParkingDiscountLogResponse } from '../../../../core/models/card.model';
import { Router } from '@angular/router';
import { PssLoadingComponent } from "../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ApiService } from '../../../../core/services/api.service';
import { ApiHandlerService } from '../../../../tools/services/api/handler-api/apiHandler.service';
import { SelectComponent } from "../../../../tools/forms/select/select.component";
import * as XLSX from 'xlsx';
import { ToastService } from 'angular-toastify';

@Component({
  selector: 'app-discount-active',
  imports: [
    CommonModule,
    FormsModule,
    InputComponent,
    PssLoadingComponent,
  ],
  templateUrl: './discount-active.component.html',
  styleUrl: './discount-active.component.css'
})
export class DiscountActiveComponent {
  // DiscountDetails
  cityparkingDiscountDetails: CityParkingDiscountDetailsResponse[] = []
  filteredCityparkingDiscountDetails: CityParkingDiscountDetailsResponse[] | null = null;
  // (Select)
  optionsActive: { name: string, value: boolean }[] = [
    { name: 'เปิดอยู่', value: false },
    { name: 'หมดอายุ', value: true }
  ]
  selectActive: { name: string, value: boolean } = { name: 'เปิดอยู่', value: false }
  isOpenSelect: boolean = false


  // Discount Log
  cityparkingDiscountLog: CityParkingDiscountLogResponse[] = []
  selectDiscountLogId: number | null = null

  // API 
  endDate: string = new Date().toISOString().slice(0, 10);
  startDate: string = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  activate: boolean = false;

  // Table
  currentPage: number = 1;
  pageSize: number = 100;

  // Search
  searchCardDiscount: string = '';

  // Modal 
  showModalDiscountLog: boolean = false;

  // Security
  isLoading: boolean = false;
  isDisabled: boolean = false;
  constructor(
    private toast: ToastService,
    private router: Router,
    private apiService: ApiService,
    private apiHandler: ApiHandlerService
  ) {

  }

  ngOnInit(): void {
    this.getApiCityparkingDiscountDetails();
  }
  /* ----------------------------------------------- Function ----------------------------------------------- */
  /* --- Style --- */
  // Table
  get filteredAndPaginatedData() {
    let data = this.cityparkingDiscountDetails;

    if (this.searchCardDiscount) {
      data = data.filter(card =>
        card.code.toLowerCase().includes(this.searchCardDiscount.toLowerCase())
      );
    }

    const start = (this.currentPage - 1) * this.pageSize;
    return data.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    const filteredLength = this.searchCardDiscount
      ? this.cityparkingDiscountDetails.filter(card =>
        card.code.toLowerCase().includes(this.searchCardDiscount.toLowerCase())
      ).length
      : this.cityparkingDiscountDetails.length;

    return Math.ceil(filteredLength / this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  // Select
  onClickSelectActive(value: any) {
    this.selectActive = value;
    this.activate = value.value
    this.isOpenSelect = false;

    ////console.log('ได้ค่าจากลูก:', this.selectActive , value);
  }

  /* --- Function --- */
  // Search
  onClickSearch() {
    if (!this.startDate || !this.endDate) {
      this.toast.error('กรุณาเลือกช่วงวันที่');
      return
    }

    this.getApiCityparkingDiscountDetails();
  }

  /* ---- Discount Details  ---- */
  // ( Search )
  onSearchCardDiscount(value: any) {
    // Perform search logic here
    this.searchCardDiscount = value;

    if (this.searchCardDiscount === '') {
      this.filteredCityparkingDiscountDetails = null;
      return;
    }

    this.filteredCityparkingDiscountDetails = this.cityparkingDiscountDetails.filter(card =>
      card.name.toLowerCase().includes(this.searchCardDiscount.toLowerCase())
    );

  }
  /* ---- Table ---- */
  // ( Copy )
  onClickCopyCode(code: string) {
    navigator.clipboard.writeText(code).then(() => {
      this.toast.success('คัดลอกเรียบร้อย');
      return;
    });
  }
  // ( Excel )
  onExportToExcel() {
    const headersCityparkingDiscountLog = [
      'id',
      'name',
      'detail',
      'remark',
      'createDate'
    ];

    // รวม headers + sample data
    const worksheet = XLSX.utils.json_to_sheet(
      this.cityparkingDiscountLog ?? [],
      { header: headersCityparkingDiscountLog }
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

    XLSX.writeFile(workbook, 'CityparkingDiscount_Template.xlsx');
  }

  navigateToDetailCreate() {
    this.router.navigate([`/discount-card-details`]);
    ////console.log("id :", id , this.router.url);
  }
  navigateToDetailById(id: number) {
    this.router.navigate([`/discount-card-details/${id}`]);
    ////console.log("id :", id , this.router.url);
  }
  onOpenModalDiscountLog(id: number) {
    this.showModalDiscountLog = true
    this.selectDiscountLogId = id
    this.getApiCityparkingDiscountLog();

    //console.log('id :', id);
  }
  onCloseModalDiscountLog() {
    this.showModalDiscountLog = false
    this.selectDiscountLogId = null
  }

  /* ----------------------------------------------- API ----------------------------------------------- */
  getApiCityparkingDiscountDetails() {
    this.apiHandler.handleApi(
      this.apiService.getApiCityParkingDiscountDetails(this.startDate, this.endDate, this.activate),
      {
        logLabel: 'getApiCityparkingDiscountDetails',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: any) => {
          this.cityparkingDiscountDetails = response;
        },
      }
    )
  }
  getApiCityparkingDiscountLog() {
    this.apiHandler.handleApi(
      this.apiService.getApiCityparkingDiscountLog(this.selectDiscountLogId ?? 0),
      {
        logLabel: 'getApiCityparkingDiscountLog',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: any) => {
          this.cityparkingDiscountLog = response;
        },
      }
    )
  }

}
